(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ym-disclosures"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ym-disclosures')) {
    customElements.define(
      'ym-disclosures',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ymBound) return;
          this.ymBound = true;
          this.addEventListener('click', (event) => {
            const content = event.target.closest('[data-ym-disclosures-content]');
            if (!content || !this.contains(content)) return;
            if (event.target.closest('.ym-disclosures__item-content, .ym-disclosures__item-header')) return;
            const item = event.target.closest('.ym-disclosures__item');
            const body = item && item.querySelector('.ym-disclosures__item-content');
            if (body && event.clientX <= body.getBoundingClientRect().right) return;
            this.querySelector('details')?.removeAttribute('open');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
